<template>
	<div class="lists-menu">
		<el-row :gutter="10" style="margin-top: 10px;">
			<el-col class="article" :span="19">
				<div class="article_txt" style="min-height: 200vh;">
					<template v-for="(item,index) in menu">
						<h2 class="article_title"><i class="el-icon-caret-right"></i>{{item.name}}</h2>
						<template v-if="item.text" v-for="i in item.text">
							<div class="img_box" v-if="i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0">
								<img :src="i" />
							</div>
							<div class="p_box" v-else>
								<p v-html="i"></p>
							</div>
						</template>
						<template v-for="(it,id) in item.child">
							<h3 class="article_title_sub" :index="index + '-' + id"><i class="el-icon-caret-right"></i>{{it.name}}</h3>
							<template v-if="it.text" v-for="i in it.text">
								<div class="img_box" v-if="i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0">
									<img :src="i" />
								</div>
								<div class="p_box" v-else>
									<p v-html="i"></p>
								</div>
							</template>
						</template>
					</template>
					<h2></h2>
				</div>
			</el-col>
			<el-col :span="5">
				<el-menu class="article_menu" :default-active="list_active" unique-opened :class="{isFixed:isFixed}">
					<template v-for="(item,index) in menu">
						<el-submenu :index="index + ''">
							<template slot="title">{{item.name}}</template>
							<el-menu-item-group>
								<template v-for="(it,id) in item.child">
									<el-menu-item :index="index + '-' + id">{{it.name}}</el-menu-item>
								</template>
							</el-menu-item-group>
						</el-submenu>
					</template>
				</el-menu>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'lists-menu',
		data() {
			return {
				isFixed:false,
				list_active:"0-0",
				y: {
					scroll: 0,
					list: 0,
					article_title:[]
				}
			}
		},
		//计算数据
		computed: {},
		//参数数据
		props: {
			"menu": null
		},
		//方法
		methods: {
			fnScroll() {
				this.y.scroll = window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop ||
					0;
			},
		},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {
			this.y.list = document.getElementsByClassName("article")[0].offsetTop + 100;
			var article_title_sub_list = document.getElementsByClassName("article_title_sub");
			for(var i=0;i<article_title_sub_list.length;i++){
				var height = article_title_sub_list[i].offsetTop + this.y.list - 80;
				var index = article_title_sub_list[i].getAttribute("index");
				
				var a = new Object();
				a.height = height;
				a.index = index;
				this.y.article_title.push(a);
			}
			
			if(window.attachEvent) {
				window.attachEvent('onscroll', this.fnScroll);
			} else if(document.addEventListener) {
				document.addEventListener('scroll', this.fnScroll, false);
			}
		},
		//监控变量
		watch: {
			"y.scroll":function(newY){
				if(newY >= this.y.list ){
					this.isFixed = true;
				}else{
					this.isFixed = false;
				}
				for(var i=0;i<this.y.article_title.length;i++){
					if(newY > this.y.article_title[i].height){
						this.list_active = this.y.article_title[i].index;
					}
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import url("../assets/common.less");
	.lists-menu {
		.el-menu {
			.el-submenu,
			.el-submenu .el-menu {
				background-color: #FFF;
				&:hover {
					background-color: #FFF;
				}
			}
			&.isFixed{
				position: fixed;
				top: 0;
			}
		}
		.article_title {
			font-size: 20px;
			line-height: 2em;
			padding: 20px 20px 20px 30px;
			i {
				font-size: 0.7em;
				color: @theme-color;
				padding-right: 15px;
			}
		}
		.article_title_sub {
			font-size: 16px;
			line-height: 2em;
			padding: 20px 20px 20px 10px;
			i {
				font-size: 0.7em;
				color: @theme-color;
				padding-right: 15px;
			}
		}
		p {
			text-indent: 2em;
			padding: 0 20px 20px;
		}
		.img_box {
			text-align: center;
			margin-bottom: 20px;
		}
		a {
			margin: 0 10px;
			&:link,
			&:visited {
				color: @theme-color;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// lists-menu.vue?37753234